const fromHostnameConfig = (hostname: string, defaultConfig: any) => {
    const awsDomainRegex = /customer-?([a-zA-Z]+[^.])?.(.*)/g;
    const regexMatch = awsDomainRegex.exec(hostname);

    if (!regexMatch) return defaultConfig;

    const [, environment, domain] = regexMatch;

    return {
        websiteUrl: `https://${environment ? `${environment}.` : ''}${domain}`,
        api: `https://svc${environment ? `-${environment}` : ''}.${domain}/api`,
        ssoConfig: {
            authority: `https://identity${environment ? `-${environment}` : ''}.${domain}`,
            post_logout_redirect_uri: `https://${environment ? `${environment}.` : ''}${domain}`
        }
    };
};

const localConfig = {
    websiteUrl: 'https://local.iitreacts.com',
    api: 'https://localsvc.iitreacts.com:8084/api',
    ssoConfig: {
        authority: 'https://localidentity.iitreacts.com:8085/',
        post_logout_redirect_uri: 'https://local.iitreacts.com'
    }
};

const localMinikubeConfig = {
    websiteUrl: 'https://local.iitreacts.com',
    api: 'https://localsvc.iitreacts.com/api',
    ssoConfig: {
        authority: 'https://localidentity.iitreacts.com/',
        post_logout_redirect_uri: 'https://local.iitreacts.com'
    }
};

const devConfig = {
    websiteUrl: 'https://dev.iit-dev.com',
    api: 'https://devsvc.iit-dev.com/api',
    ssoConfig: {
        authority: 'https://devidentity.iit-dev.com',
        post_logout_redirect_uri: 'https://dev.iit-dev.com'
    }
};

const uatConfig = {
    websiteUrl: 'https://uat.iit-dev.com',
    api: 'https://uatsvc.iit-dev.com/api',
    ssoConfig: {
        authority: 'https://uatidentity.iit-dev.com',
        post_logout_redirect_uri: 'https://uat.iit-dev.com'
    }
};

const stagingConfig = {
    websiteUrl: 'https://staging.reacts.com',
    api: 'https://stagingsvc.reacts.com/api',
    ssoConfig: {
        authority: 'https://stagingidentity.reacts.com',
        post_logout_redirect_uri: 'https://staging.reacts.com'
    }
};

const patchConfig = {
    websiteUrl: 'https://patch.reacts.com',
    api: 'https://patchsvc.reacts.com/api',
    ssoConfig: {
        authority: 'https://patchidentity.reacts.com',
        post_logout_redirect_uri: 'https://patch.reacts.com'
    }
};

const prodConfig = {
    websiteUrl: 'https://reacts.com',
    api: 'https://svc.reacts.com/api',
    ssoConfig: {
        authority: 'https://identity.reacts.com',
        post_logout_redirect_uri: 'https://www.reacts.com'
    }
};

export default (originalConfig: any) => (location: Location) => {
    let config = {...originalConfig};
    const {host, hostname} = location;
    let merge = (configToMerge: any, override: any) => (
        {
            ...configToMerge,
            websiteUrl: override.websiteUrl,
            api: override.api,
            ssoConfig: {
                ...configToMerge.ssoConfig,
                ...override.ssoConfig,
                redirect_uri: `${origin}/callback`
            }
        });
    
    switch (host) {
        case 'localcustomer.iitreacts.com:8087':
            config = merge(config, localConfig);
            break;
        case 'localcustomer.iitreacts.com':
            config = merge(config, localMinikubeConfig);
            break;
        case 'devcustomer.iit-dev.com':
            config = merge(config, devConfig);
            break;
        case 'uatcustomer.iit-dev.com':
            config = merge(config, uatConfig);
            break;
        case 'stagingcustomer.iitreacts.com':
        case 'stagingcustomer.reacts.com':
            config = merge(config, stagingConfig);
            break;
        case 'patchcustomer.iitreacts.com':
        case 'patchcustomer.reacts.com':
            config = merge(config, patchConfig);
            break;
        case 'customer.iitreacts.com':
        case 'customer.reacts.com':
            config = merge(config, prodConfig);
            break;
        default:
            config = merge(config, fromHostnameConfig(hostname, localConfig)); 
            break;
    }

    return config;
};
